import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
import { Modal } from "../../atoms/modals/antd-modals";
import { Button } from "../../atoms/buttons/buttons";
import { TimePicker } from "antd";
import Form from "antd/es/form";
import "antd/es/form/style";
import styles from "./style.module.scss";
import shiftApi from "../../../utilities/api/shift";
import openNotification from "../../../utilities/openNotification";
import FeatherIcon from "feather-icons-react";
import { isEmpty } from "lodash";

function BreakModalEdit(props) {
    const [form] = Form.useForm();
    const [modalVisible, setModalVisible] = React.useState(false);
    const [selectedTime, setSelectedTime] = useState(null);
    const { showEditBreakModal,
        breakObj,
        setShowEditBreakModal,
        slotOptions,
        refetch,
        refetchWaivableFees,
        setIsLoading,
        location_id,
        session_date,
        apptRange,
        break_minutes
    } = props;

    useEffect(() => {
        setSelectedTime("");
        form.setFieldsValue({
            "start-time": "",
        });
        setModalVisible(showEditBreakModal);
    }, [showEditBreakModal])


    const breakModal = () => {
        if (!modalVisible) return null;
        return <Modal
            className="no-lines-modal"
            closable={true}
            centered
            visible={modalVisible}
            onCancel={() => {
                setShowEditBreakModal(false);
            }}
            title={<div className="color-dark">Move Break</div>}
            footer={[
                {
                    size: "large",
                    type: "primary",
                    text: "Move Break >",
                    style: {
                        fontSize: "14px",
                        lineHeight: "16px"
                    },
                    onClick: onSubmit,
                    disabled: !selectedTime
                },
            ].map((button, index) => (
                <Button
                    className={button.className}
                    key={`brk-modal-btn-${index}`}
                    size={button.size}
                    type={button.type}
                    outlined={button.outlined}
                    onClick={button.onClick}
                    style={button.style}
                    disabled={button.disabled}
                >
                    {button.text}
                </Button>
            ))}
        >
            <p>Please choose a time slot.</p>
            <Form
                form={form}
                name="reasons"
                onFinish={(e) => e?.preventDefault()}
                layout="vertical"
            >
                <Form.Item
                    colon={false}
                    name="start-time"
                    label="Start Time"
                    rules={[{ required: true, message: "Start time is required!" }]}
                >
                    <TimePicker
                        className={styles["select_handler"]}
                        popupClassName={styles["time-picker-popup"]}
                        suffixIcon={
                            <FeatherIcon icon="clock" size={16} color="#586B94" />
                        }
                        use12Hours
                        allowClear={false}
                        onSelect={(time) => {
                            setSelectedTime(moment(time));
                            form.setFieldsValue({
                                "start-time": moment(time),
                            });
                        }}
                        minuteStep={5}
                        inputReadOnly
                        format="h:mm A"
                        showNow={false}
                        initialValues={selectedTime}
                        disabledTime={() => {
                            if (!apptRange || !apptRange.start || !apptRange.end) {
                                return {};
                            }
                            const disabledHours = () => {
                                const hours = [];
                                const startHour = moment(apptRange.start).hour();
                                const endHour = moment(apptRange.end).hour();
                                for (let i = 0; i < startHour; i++) {
                                    if (i < startHour || i > endHour) {
                                        hours.push(i);
                                    }
                                }
                                for (let i = endHour + 1; i < 24; i++) {
                                    hours.push(i);
                                }
                                return hours;
                            }

                            const disabledMinutes = (selectedHour) => {
                                const minutes = [];
                                const startMinute = moment(apptRange.start).minute();
                                const endMinute = moment(apptRange.end).minute();
                                if (selectedHour === moment(apptRange.start).hour()) {
                                    for (let i = 0; i < startMinute; i += 5) {
                                        minutes.push(i);
                                    }
                                }
                                if (selectedHour === moment(apptRange.end).hour()) {
                                    for (let i = endMinute; i < 60; i += 5) {
                                        minutes.push(i);
                                    }
                                }
                                return minutes;
                            }

                            return {
                                disabledHours,
                                disabledMinutes
                            };
                        }}
                    />
                </Form.Item>
            </Form>
        </Modal>
    }
    const onSubmit = () => {
        if (!selectedTime || isEmpty(apptRange)) return;
        let tempTime = apptRange.start.clone().set({
            hour: selectedTime.hour(),
            minute: selectedTime.minute()
        });
        if (tempTime.isBefore(apptRange.start) || tempTime.isAfter(apptRange.end)) {
            openNotification("Error", "Selected time is out of appointment range.", "error");
            return;
        }

        setIsLoading(true);
        shiftApi.editBreakInSlot({
            location_id,
            session_date: session_date,
            session_time: selectedTime.format("h:mm A"),
            session_end_time: selectedTime.clone().add(breakObj?.currentLength, "minutes").format("h:mm A"),
            slot_id: breakObj.id,
        }).then((res) => {
            setIsLoading(false);
            openNotification("Success", res.data.message, "success");
            refetch();
            refetchWaivableFees();
            setShowEditBreakModal(false);
        }).catch((err) => {
            setIsLoading(false);
            openNotification("Error", err.response.data.message, "error");
        });
    }
    return (
        <div>
            {breakModal()}
        </div>
    )
}
export default BreakModalEdit;